/**
 * nosto-collection-pushs.js
 * --------------------------
 * Injecte les card-push (sérialisés SSR par main-collection-nosto.liquid dans
 * le JSON island #nosto-pushs-data) DANS la grille produit rendue par Nosto
 * (Preact) à l'intérieur de #nosto-content — aux MÊMES positions que le natif
 * (desktop = posDesktop, mobile = posMobile), avec les mêmes classes de
 * visibilité Dawn (`small-hide` desktop / `medium-hide large-up-hide` mobile).
 *
 * Nosto re-rend la grille à chaque changement (filtre / tri / page) : on
 * observe #nosto-content et on ré-injecte (idempotent) après chaque rendu.
 * lazy_load:false côté Liquid → les images des pushs sont déjà en `src`.
 */
(function () {
  'use strict';

  var DATA_ID = 'nosto-pushs-data';
  var GRID_SELECTOR = '#nosto-content ul.product-grid, #nosto-content ul.grid';
  var pushes = null;
  var observer = null;
  var debounceTimer = null;

  function loadPushes() {
    if (pushes !== null) return pushes;
    var el = document.getElementById(DATA_ID);
    if (!el) return (pushes = []);
    try {
      var data = JSON.parse(el.textContent || '[]');
      pushes = Array.isArray(data) ? data : [];
    } catch (e) {
      pushes = [];
    }
    return pushes;
  }

  function buildPushLi(html, isMobile) {
    var li = document.createElement('li');
    li.className = 'grid__item nosto-push ' + (isMobile ? 'medium-hide large-up-hide' : 'small-hide');
    li.setAttribute('data-nosto-push', '1');
    li.innerHTML = html;
    return li;
  }

  // Produits actuels (les <li> qui ne sont pas des pushs déjà injectés).
  function productItems(grid) {
    return Array.prototype.filter.call(grid.children, function (node) {
      return node.tagName === 'LI' && !node.hasAttribute('data-nosto-push');
    });
  }

  function inject() {
    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;
    var list = loadPushes();
    if (!list.length) return;

    // On modifie la grille → couper l'observer pour ne pas se ré-déclencher soi-même.
    if (observer) observer.disconnect();

    // Idempotent : retirer les pushs déjà injectés avant de réinsérer.
    Array.prototype.slice
      .call(grid.querySelectorAll('li[data-nosto-push]'))
      .forEach(function (n) { n.remove(); });

    list.forEach(function (p) {
      // Desktop : la card-push apparaît APRÈS le posDesktop-ème produit (iso natif).
      var prods = productItems(grid);
      var refD = prods[p.posDesktop] || null; // insertBefore(ref) → après le posDesktop-ème
      grid.insertBefore(buildPushLi(p.html, false), refD);

      // Mobile : position indépendante (posMobile).
      var prodsM = productItems(grid);
      var refM = prodsM[p.posMobile] || null;
      grid.insertBefore(buildPushLi(p.html, true), refM);
    });

    // Réactiver le lazy-load du thème pour d'éventuels médias dans la card-push.
    document.dispatchEvent(new CustomEvent('reactivateLazyObserver'));

    // Reconnecter l'observer.
    startObserver();
  }

  function scheduleInject() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(inject, 120);
  }

  function startObserver() {
    var content = document.getElementById('nosto-content');
    if (!content) return;
    if (!observer) {
      observer = new MutationObserver(function (mutations) {
        // Ignorer nos propres mutations (pushs) — on ne réagit qu'aux li produits.
        var relevant = mutations.some(function (m) {
          if (m.type !== 'childList') return false;
          return Array.prototype.some.call(m.addedNodes, function (n) {
            return n.nodeType === 1 && !n.hasAttribute('data-nosto-push');
          });
        });
        if (relevant) scheduleInject();
      });
    }
    observer.observe(content, { childList: true, subtree: true });
  }

  function init() {
    startObserver();
    scheduleInject(); // premier passage (au cas où la grille est déjà rendue)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
